import { useCallback } from 'react';
import { toPng, getFontEmbedCSS } from 'html-to-image';
import type { Options } from 'html-to-image/src/types';
import { saveAs } from 'file-saver';

const useScreenshot = () => {
    const generatePng = useCallback(
        async (ref: HTMLElement, name: string, options: Options = {}) => {
            if (ref === null) {
                return;
            }
            try {
                const fontEmbedCSS = await getFontEmbedCSS(ref);
                const screenShot = await toPng(ref, {
                    ...options,
                    fontEmbedCSS,
                    includeQueryParams: true
                });
                saveAs(screenShot, `${name ?? 'export'}.png`);
            } catch (error) {
                console.error(error);
            }
        },
        []
    );

    return { generatePng };
};

export default useScreenshot;
